import React from "react";
// material ui
import { Button, Grid, Paper, Typography } from "@mui/material";
// files
import ProfleWithIcon from "../Widgets/ProfileWithIcon";
import AvatarIcon from "../Icons/AvatarIcon";

import "./Header.scss";

function Header(props) {
  const { data } = props;

  // function
  const getName = (name) => {
    if (name != undefined || name != null) {
      return name;
    }
    return "-";
  };

  const getRole = (role) => {
    if (role != undefined || role != null) {
      return role;
    }
    return "-";
  };

  const headerRM =
    data?.profileWithIcon?.userData.relationshipManager ?? data?.profileWithIcon?.userData.accountManager;

  return (
    <Grid
      container
      direction="row"
      rowSpacing={3}
      size={{
        lg: 12,
        xs: 12
      }}
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start"
      }}>
      <Grid size="auto">
        {data && (
          <Grid container direction="row" columnSpacing={3} size="auto" sx={{
            alignItems: "flex-end"
          }}>
            <Grid size="auto">
              <Typography variant="h1">{data.heading}</Typography>

              <Typography
                variant="h6"
                sx={[{
                  pt: 1,
                  letterSpacing: data.letterSpacing
                }, data.subHeaderColor != null ? data.subHeaderColor : { color: "#43425D" }]}>
                {data.subHeader}
              </Typography>
            </Grid>
            {data.subHeader != null &&
            data.subHeaderButton != null &&
            data.subHeaderButton != false &&
            data.customerSubscription?.status == "incomplete" ? (
              <Grid size="auto">
                <Button
                  variant="contained"
                  className="header-run-again-btn"
                  sx={{
                    pt: "5px",
                    pl: "10px",
                    pr: "10px",
                    pb: "5px",
                    // mt: "-8px",
                    borderRadius: 2,
                    backgroundColor: "warning.main",
                  }}
                  onClick={() => window.open(`${data.customerSubscription?.invoice_link}`)}
                >
                  <Typography variant="paragraph" color="white" sx={{
                    fontWeight: "550"
                  }}>
                    Run Again
                  </Typography>
                </Button>
              </Grid>
            ) : null}
          </Grid>
        )}
      </Grid>
      {data && data.profileWithIcon != null ? (
        <Grid
          size={{
            lg: 3,
            md: 5,
            sm: 8,
            xs: 12
          }}>
          <Paper sx={{ p: 2 }}>
            <ProfleWithIcon
              // data={data.profileWithIcon.userData}
              data={
                data.profileWithIcon.userData != null
                  ? {
                      name: `${getName(headerRM?.firstName)}  ${getName(headerRM?.lastName)}`,
                      //   (data.profileWithIcon.userData
                      //       .accountManager
                      //       ? data.profileWithIcon
                      //             .userData.accountManager
                      //             .First_Name
                      //           ? data.profileWithIcon
                      //                 .userData
                      //                 .accountManager
                      //                 .First_Name
                      //           : "-"
                      //       : "-") +
                      //   " " +
                      //   "----",

                      role: getRole(headerRM?.email),
                    }
                  : null
              }
              icon={<AvatarIcon shape={data.profileWithIcon.shape} />}
              // shape={data.profileWithIcon.shape}
            />
          </Paper>
        </Grid>
      ) : null}
    </Grid>
  );
}

export default Header;
